import TurboNativeAppStateObserver from '../observers/turbo_native_app_state_observer';

const observer = new TurboNativeAppStateObserver();
observer.start();
